import React from 'react';

import { Box, Heading, Text, BorderBox, Flex } from '@primer/components'
import hljs from 'highlight.js'
import Editor from 'react-simple-code-editor';

import NextButton from './NextButton' 
import FormButton from './FormButton'
import CodeEditorFooterDiff from './CodeEditorFooterDiff'
import CodeEditorFooterReport from './CodeEditorFooterReport'
import CodeEditorFooterValidationError from './CodeEditorFooterValidationError'


const commentStyle = {
  fontFamily: '"Fira code", "Fira Mono", monospace',
  fontSize: '16px',
  whiteSpace: 'pre-wrap',
  wordBreak: 'keep-all',
  overflowWrap: 'break-word',
}

export default function CodeEditor(props) {
  const { onSaveClick, onNextClick, messages, validationError, isLastQuestion, ...otherProps } = props
  const nextButton = <NextButton disabled={props.readOnly} onClick={onNextClick} isLastQuestion={isLastQuestion} />

  function handleKeyDown(event) {
    // control+z causes back in time bug
    if ((event.ctrlKey || event.metaKey) && event.keyCode === 90) {
      event.preventDefault();
      return false;
    }
  }
  return (
    <Box className="">
      <BorderBox>
        <Box className="bg-gray p-2 f5 text-mono">{props.filepath}</Box>
        <Text className="hljs-comment p-2" as="pre" style={commentStyle}>{props.comment}</Text>
        <Editor
          {...otherProps}
          highlight={code => hljs.highlight('python', code).value}
          padding={10}
          style={{
            fontFamily: '"Fira code", "Fira Mono", monospace',
            fontSize: 16,
          }}
          onKeyDown={handleKeyDown}
        />
        <Box className="bg-gray p-2 f5">
          <Flex justifyContent='space-between'>
            <div style={{width: '100%'}}>
              <FormButton
                secondary={(messages && messages.length === 0) || props.diffBefore || props.readOnly}
                isInProgress={props.isInProgress}
                disabled={props.readOnly}
                onClick={onSaveClick}
                label={'Check'}
              />
              { validationError && <CodeEditorFooterValidationError error={validationError} /> }
              { messages && (
                  <CodeEditorFooterReport
                    messages={messages}
                    onFixClick={props.onFixClick}
                    disabled={props.readOnly}
                    isInProgress={props.isInProgress}
                  />
                )
              }
              { props.diffBefore && (
                  <CodeEditorFooterDiff
                    diffBefore={props.diffBefore}
                    diffAfter={props.value}
                    messageIds={props.diffMessageIds}
                    nextButton={nextButton}
                  />
                )
              }
            </div>
              {
                !props.diffBefore && (
                  <FormButton
                    secondary={true}
                    isInProgress={props.isInProgress}
                    disabled={props.readOnly}
                    onClick={otherProps.onFixClick}
                    label={'I give up. Fix it for me'}
                    style={{height: '2.5em'}}
                  />
                )
              }
          </Flex>
          { messages && messages.length === 0 && nextButton}
        </Box>
      </BorderBox>

      { props.showLinks && <HelpfulLinks resources={props.resources} category={props.category} /> }
    </Box>
  )
}

function HelpfulLinks(props) {
  return (
    <Box>
      <Heading fontSize={3} className="mt-6">Helpful links</Heading>
      <ul className="bullet-list-blue">
         <li><a href={`/advice/${props.category}`}>Read about our {props.category} checkers</a></li>
        { 
          props.resources.length > 0 && (
            props.resources.map(({text, href}) => <li><a href={href} rel="noopener noreferrer" target="_blank">{text}</a></li>)
          )
        }
      </ul>
    </Box>
  )
}

